<template>
  <v-card :width="width" class="mt-0 mb-3 card-style"
          :class="{ 'card-style-active': isClicked }"
          style="cursor: pointer;"
          @click.prevent.stop="goToChannel(channelIdx, idx)"
          @touchstart="touchEnable">
    <!-- 메인 슬라이딩 카드 -->
    <v-card-text class="pb-0" v-if="width">
      <v-layout row wrap>
        <v-flex class="text-xs-left"
                :class="imageList ? 'xs8 pr-2' : 'xs12'"
                style="min-height: 80px;">
          <p class="body-2 mb-0" v-text="contents"></p>
          <p class="tag-style mb-0" v-if="hashtag">
            <span class="d-inline-block mr-1" v-for="tag in hashtag" :key="tag" v-text="`#${tag}`"></span>
          </p>
        </v-flex>
        <v-flex xs4 v-if="imageList">
          <v-img aspect-ratio="1" :src="smallImageSrc" lazy-src="@/assets/img/thumbnail-small-default.png" @error="isImageLoaded = false" style="position: relative">
            <v-icon color="white" size="16px" style="position: absolute; right: 6px; top: 6px;" v-if="imageList.length > 1">$vuetify.icons.images</v-icon>
          </v-img>
        </v-flex>
      </v-layout>
    </v-card-text>

    <!-- 화면 꽉 채우는 카드 -->
    <v-card-text class="pa-0" v-else>
      <div v-if="imageList" style="background-color: white;" :class="imageList.length === 1 ? `mb-3` : ''">
        <div class="swiper-container" :class="`feed-swiper-container-${idx}`">
          <div class="swiper-wrapper" :class="`feed-swiper-wrapper-${idx}`">
            <div class="swiper-slide" :class="`feed-swiper-slide-${idx}`" v-for="(image, index) of imageList" :key="index">
              <!-- TODO: fallback image list -->
              <v-img :src="`${$storage}/post/${image}`"
                     :aspect-ratio="16/9"
                     class="grey lighten-5">
                <template v-slot:placeholder>
                  <v-layout fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="grey"></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>
            </div>
          </div>

          <div v-show="imageList.length > 1" class="swiper-pagination" :class="`feed-swiper-pagination-${idx}`"></div>
        </div>
      </div>

      <v-layout row wrap class="px-3 pb-0" :class="imageList && imageList.length === 1 ? 'pt-0' : 'pt-3'">
        <v-flex xs12 class="text-xs-left">
          <p v-if="typeof channelTitle !== 'undefined'"
             class="mb-0" style="font-weight: 700; color: #4a4a4a;">
            {{ channelTitle }}
          </p>
          <p class="body-2 clamp-more mb-0" :class="{ desktop: desktop }" v-text="contents"></p>
          <p class="tag-style mb-0" v-if="hashtag">
            <span class="d-inline-block mr-1" v-for="tag in hashtag" :key="tag" v-text="`#${tag}`"></span>
          </p>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="pa-0">
      <v-list-tile class="grow pt-3 pb-1">
        <v-list-tile-avatar size="16px" class="mr-2" style="min-width: 0; margin-bottom: 12px;">
          <v-img size="16px" :src="profileImageSrc" lazy-src="@/assets/img/profile-default.png" @error="isProfileLoaded = false"></v-img>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <span class="user-name" v-text="userName"></span>
          <span class="caption">{{ published }}</span>
        </v-list-tile-content>

        <v-layout align-center justify-end>
          <v-layout column align-center style="flex-shrink: 0; flex-grow: 0; width: 24px;">
            <v-btn icon small @click.prevent.stop="like">
              <v-icon :color="likes ? '#ec2f54' : '#4a4a4a'">{{ likes ? '$vuetify.icons.heartFilled' : '$vuetify.icons.heartOutlined' }}</v-icon>
            </v-btn>
            <span class="counter" v-text="likeCnt"></span>
          </v-layout>

          <v-layout column align-center class="ml-4 mr-2" style="flex-shrink: 0; flex-grow: 0; width: 24px;">
            <v-btn icon small @click.prevent.stop="readFeed(idx)">
              <v-icon color="#4a4a4a">$vuetify.icons.commentOutlined</v-icon>
            </v-btn>
            <span class="counter" v-text="commentCnt"></span>
          </v-layout>

          <v-layout column align-center class="ml-3" v-if="!width" style="flex-shrink: 0; flex-grow: 0; width: 24px;">
            <v-btn icon small @click.prevent.stop="bookmark">
              <v-icon color="#4a4a4a">{{ bookmarks ? '$vuetify.icons.bookmarkFilled' : '$vuetify.icons.bookmarkOutlined' }}</v-icon>
            </v-btn>
            <span class="counter" v-text="bookmarkCnt"></span>
          </v-layout>
        </v-layout>

      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';

  import { timeToDotString } from '@/util/util'
  import { mapGetters } from 'vuex';

  export default {
    name: 'FeedCard',
    props: [
      'desktop', 'width', 'channelTitle', 'channelIdx',
      'idx', 'contents', 'hashtag', 'imageList', 'userName', 'userProfileImage',
      'createdAt', 'likes', 'likeCnt', 'bookmarks', 'bookmarkCnt', 'commentCnt'
    ],
    computed: {
      ...mapGetters([ 'now' ]),
      ...mapGetters('user', { userIdx: 'idx' }),
      profileImageSrc () {
        return this.userProfileImage && this.isProfileLoaded ? `${this.$storage}/user/profile/${this.userProfileImage}` : require('@/assets/img/profile-default.png');
      },
      smallImageSrc () {
        return this.imageList && this.isImageLoaded ? `${this.$storage}/post/${this.imageList[0]}` : require('@/assets/img/thumbnail-small-default.png');
      },
      published () {
        return timeToDotString(this.createdAt, this.createdAt, this.now);
      }
    },
    data () {
      return {
        isClicked: false,
        isProfileLoaded: true,
        isImageLoaded: true,
        swiper: null,
      };
    },
    mounted () {
      if (!this.width && this.imageList) {
        this.swiper = new Swiper(`.feed-swiper-container-${this.idx}`, {
          direction: 'horizontal',
          // width: (window.innerWidth - 32),
          // height: (window.innerWidth - 32) * 9 / 16,
          pagination: {
            el: `.feed-swiper-pagination-${this.idx}`,
          },
        });
      }
    },
    updated () {
      if (this.swiper) this.swiper.update();
      else if (!this.width && this.imageList) {
        this.swiper = new Swiper(`.feed-swiper-container-${this.idx}`, {
          direction: 'horizontal',
          // width: (window.innerWidth - 32),
          // height: (window.innerWidth - 32) * 9 / 16,
          pagination: {
            el: `.feed-swiper-pagination-${this.idx}`,
          },
        });
      }
    },
    beforeDestroy () {
      if (this.swiper) this.swiper.destroy(true, true);
    },
    methods: {
      goToChannel (channelIdx, idx) {
        this.isClicked = true;
        setTimeout(() => {
          // TODO: 피드 게시글 목록으로 스크롤
          // 근데... 너무 오래된 글이면 어떻게 함 ?? 일단 보류
          // this.$router.push({ name: 'Channel', params: { idx: channelIdx }, query: { post: idx } });
          this.$router.push({ name: 'ReadFeed', params: { idx } });
        }, 200);
      },
      readFeed (idx) {
        // setTimeout(() => {
        this.$router.push({ name: 'ReadFeed', params: { idx } });
        // }, 200);
      },
      like () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else this.$emit('like');
      },
      bookmark () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else this.$emit('bookmark');
      },
      touchCancel () {
        this.$eventBus.$emit('touchCancel', true);
      },
      touchEnable () {
        this.$eventBus.$emit('touchCancel', false);
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import '../scss/custom';

  .card-style {
    overflow: hidden;
    border: 1px solid;
    border-color: map_get($colors, border) !important;
    border-radius: 5px !important;
    box-shadow: 0 10px 10px rgba(#9b9b9b, 0.25) !important;
    &-active {
      transform: scale(0.98);
      box-shadow: 0 5px 5px rgba(#9b9b9b, 0.25) !important;
    }
  }

  .body-2 {
    line-height: 20px;
    word-break: keep-all;
    word-wrap: break-word;

    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    position: relative;
    z-index: 0;
    &.clamp-more {
      -webkit-line-clamp: 5;
    }
    &.desktop {
      white-space: pre-wrap;
      -webkit-line-clamp: unset;
    }
  }

  .tag-style {
    line-height: 20px;
    height: 20px;
    overflow: hidden;

    background-color: white;
    position: relative;
    /*z-index: 1;*/
    z-index: 0;
  }

  .user-name {
    color: map_get($colors, brownish-grey);
    font-size: 10px;
  }

  .caption {
    color: map_get($colors, brownish-grey);
    font-size: 10px !important;
  }

  .counter {
    color: map_get($colors, brownish-grey);
    font-size: 10px;
    /*font-weight: 700;*/
    line-height: 14px;
    margin-top: -5px;
    //letter-spacing: -0.2px;
  }

  .swiper-container {
    width: 100%;
    /*height: calc((100vw - 32px) * 9 / 16 + 21px);*/
  }

  /deep/.swiper-pagination {
    position: relative;
    bottom: 0;

    .swiper-pagination-bullet {
      display: inline-block;
      width: 6px;
      height: 6px;
      opacity: 1;
      background: map_get($colors, background-shadow);;
      border-radius: 50%;
    }
    .swiper-pagination-bullet-active {
      background: #ec2f54;
    }
  }

</style>
